import React from 'react';
import { Chrome } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Alert, AlertDescription } from '../../components/ui/alert';
import { usePrepAuth } from '../../contexts/PrepAuthContext';

export const PrepLogin = () => {
  const { login } = usePrepAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <Card className="border-2 shadow-2xl">
          <CardHeader className="text-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_push-life-rescue/artifacts/p11bt5xn_IMG_1085.PNG" 
              alt="PUSH Training Prep Logo" 
              className="h-20 w-auto mx-auto mb-4"
            />
            <CardTitle className="text-2xl font-bold">Welcome to Certification Prep</CardTitle>
            <CardDescription className="text-base">
              Sign in to access your courses and materials
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <Alert className="bg-blue-50 border-blue-200">
              <AlertDescription className="text-sm text-gray-700">
                Use your Google account to sign in securely. New users will be automatically registered.
              </AlertDescription>
            </Alert>

            <Button 
              onClick={login}
              className="w-full bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-300 text-lg py-6 font-medium"
            >
              <Chrome className="mr-3" size={24} />
              Sign in with Google
            </Button>

            <div className="pt-6 border-t">
              <p className="text-sm text-gray-600 text-center">
                By signing in, you agree to our Terms of Service and Privacy Policy.
              </p>
            </div>

            <div className="text-center">
              <p className="text-sm text-gray-600 mb-2">Don't have an account?</p>
              <p className="text-sm text-gray-700">
                New users are automatically registered on first sign-in.
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <a href="/prep" className="text-blue-200 hover:text-white text-sm">
            ← Back to Certification Prep Home
          </a>
        </div>
      </div>
    </div>
  );
};
